import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Stack, Divider, useStyleConfig} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import {DownloadIcon} from '../../../components/icons/others'
import {remCalc} from '../../../theme/_utils'
import ProductTips from './product-tips'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import routingObject from '../../../utils/static-routes'

const ProductDocumentation = ({product}) => {
    const {formatMessage} = useIntl()
    const styles = useStyleConfig('ProductDocumentation')
    const navigate = useNavigation()
    return (
        <Flex {...styles.pDocContainer}>
            <Stack {...styles.pdfTipsStack}>
                <Button
                    {...styles.buttonPadding}
                    data-testid="product-documentation-button"
                    variant={'text-button'}
                    onClick={() =>
                        product?.variationValues?.skuIdentifier &&
                        navigate(`/s/${product.variationValues.skuIdentifier}`)
                    }
                >
                    {formatMessage({
                        defaultMessage: 'Visit Instruction Manual',
                        id: 'product_detail.product_documentation.manual',
                    })}
                </Button>
                <DownloadIcon data-testid="download-icon" {...styles.downloadIcon} />
            </Stack>
            <Divider {...styles.pDocDivider} aria-orientation="vertical" role="separator" />
            <Stack {...styles.pdfTipsStack}>
                <Button
                    {...styles.buttonPadding}
                    data-testid="product-documentation-button"
                    variant={'text-button'}
                    onClick={() =>
                        product?.id &&
                        navigate(
                            `${routingObject.PRODUCT_REGISTRATION_PATH}/select?text=${product.id}`,
                        )
                    }
                >
                    {formatMessage({
                        defaultMessage: 'Register your product',
                        id: 'product_detail.product_documentation.register',
                    })}
                </Button>
                <Stack gap={remCalc(7)}>
                    <ProductTips />
                </Stack>
            </Stack>
        </Flex>
    )
}

ProductDocumentation.propTypes = {
    product: PropTypes.object,
}

export default ProductDocumentation
